import {
  LOGOUT_USER,
  CLEAR_PENDIENTE_DATA,
  CLEAR_HISTORICO_DATA,
} from "../../../constants/ActionTypes";

const logout = (history) => (
  dispatch,
  pendienteDispatch,
  historicoDispatch
) => {
  sessionStorage.removeItem("token");

  dispatch({ type: LOGOUT_USER });
  pendienteDispatch({ type: CLEAR_PENDIENTE_DATA });
  historicoDispatch({ type: CLEAR_HISTORICO_DATA });

  history.push("/");
};

export default logout;
